export const scheduleFilter = (rows) => {
  const dataBeforeToday = rows.filter(
    (row) => new Date(row.paymentDate) < new Date()
  );
  const totalAmount = dataBeforeToday.reduce(
    (sum, current) => sum + Number(current.amount),
    0
  );
  return totalAmount.toFixed(3);
};

export const paymentFilter = (rows, paymentCode) => {
  // console.log("rows", rows)
  // console.log("paymentCode", paymentCode)
  const paymentFilter = rows.filter(
    (row) => row.attributes.payment_code.data[0].attributes.code === paymentCode
  );

  const totalAmount = paymentFilter.reduce(
    (sum, current) => sum + current.attributes.amount,
    0
  );
  return totalAmount.toFixed(2);
};
